import React from 'react';
import type { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon';
const CMP = (props: Partial<CustomIconComponentProps>) => (
  <svg viewBox="0 0 18 18" width={18} height={18} {...props}>
    <g id="代理中心" transform="translate(-69.623 -107.519)" opacity="0.65" fill="currentColor">
      <path
        id="路径_9250"
        data-name="路径 9250"
        d="M81.874,114.583h-6.5A1.433,1.433,0,0,1,74.02,113.1V109a1.433,1.433,0,0,1,1.354-1.481h6.5A1.433,1.433,0,0,1,83.228,109v4.1a1.433,1.433,0,0,1-1.354,1.483Zm-6.374-1.6h6.25v-3.873H75.5ZM86.27,125.52H80.947a1.422,1.422,0,0,1-1.354-1.481v-3.725a1.422,1.422,0,0,1,1.354-1.481H86.27a1.422,1.422,0,0,1,1.354,1.481v3.725a1.433,1.433,0,0,1-1.354,1.481Zm-5.208-1.6h5.115v-3.5H81.051Zm-4.762,1.6H70.989a1.432,1.432,0,0,1-1.365-1.481v-3.725a1.569,1.569,0,0,1,.392-1.07,1.309,1.309,0,0,1,.972-.445H76.3a1.422,1.422,0,0,1,1.354,1.481v3.759A1.422,1.422,0,0,1,76.3,125.52Zm-5.208-1.6h5.1v-3.5H71.083Z"
      />
      <path
        id="路径_9251"
        data-name="路径 9251"
        d="M242.839,498.168H241.38v-1.481h-8.542v1.47h-1.417v-1.481a1.5,1.5,0,0,1,1.417-1.572h8.583a1.37,1.37,0,0,1,1.01.469,1.642,1.642,0,0,1,.407,1.114Z"
        transform="translate(-158.506 -378.96)"
      />
      <path id="路径_9252" data-name="路径 9252" d="M476.16,389.12h1.458v2.8H476.16Z" transform="translate(-398.265 -275.334)" />
    </g>
  </svg>
);

export default CMP;
